import { Directive, ElementRef, Input, OnChanges, OnInit } from "@angular/core";
import { TranslationService } from "@services/translation.service";

@Directive({
    selector: "[translate]"
})
export class TranslateDirective implements OnChanges {
    @Input() translate: string;
    @Input() translateParams: any;

    constructor(
        private readonly element: ElementRef,
        private readonly translationService: TranslationService
    ) { }

    ngOnChanges() {
        this.translatePhrase(this.translate, this.translateParams);
    }

    translatePhrase(phrase: string, params?: any) {
        this.element.nativeElement.innerHTML = '';
        this.element.nativeElement.innerHTML = this.translationService.t(phrase, params);
    }
}
